// noinspection ES6UnusedImports
import React from 'react';
import WishlistHeart from '@core/scripts/components/wishlist/heart';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';

export default function ProductImageWishlistHeart({product, currentItem, currentItemOption, fullWidth}) {

    const onItemAddCompleted = () => {
        MessageBroker.publish('WISH_STATS.UPDATE');
    };

    const onItemRemoveCompleted = () => {
        MessageBroker.publish('WISH_STATS.UPDATE');
    };

    return <WishlistHeart
        className={fullWidth ? "product-image-wishlist-heart__full_width" : "product-image-wishlist-heart"}
        digistyleId={product.styleId}
        masterStyleId={product.masterStyleId}
        articleNumber={currentItem?.itemNumber}
        promotion={product.promotion}
        articlePrice={currentItemOption?.price?.unified?.value || currentItem?.price?.unified?.value}
        shopId={product.shopId}
        itemId={currentItem?.id}
        itemOptionId={currentItemOption?.id}
        itemOptionName={currentItemOption?.name}
        origin="adp_heart_on_pic"
        isMultiItem
        onAddSuccess={onItemAddCompleted}
        onRemoveSuccess={onItemRemoveCompleted}
    />

}
